import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
export default function (obj, filterFn) {
  var retProps = {};

  if (obj) {
    Object.keys(obj).filter(function (key) {
      return filterFn(key, obj[key]);
    }).forEach(function (key) {
      retProps[key] = obj[key];
    });
  }

  return retProps;
}